module.exports = __webpack_public_path__ + "img/sp5.49d7345d.png";